<script setup>
import { trans } from '@elements/translation';

const emit = defineEmits([ 'click' ]);
</script>

<template>
  <button
    class="show-list-button"
    @click.prevent="emit('click')"
  >
    <span>{{ trans('selection_item.view.list') }}</span>
  </button>
</template>
